function openTabFeed(evt, sectionId, tabName) {
  const triggerButton = evt?.currentTarget;
  const parentSection = triggerButton?.closest(".section");

  /* --------------- *** Hide All Tabs *** --------------- */

  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );

  if (!tabcontent.length) return;

  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  /* --------------- *** Deactivate All Tab Buttons *** --------------- */

  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );

  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  /* --------------- *** Show Active Tab *** --------------- */

  const targetTab = document.getElementById(tabName);

  if (!targetTab) return;

  targetTab.style.display = "block";

  if (triggerButton) {
    triggerButton.className += " active";
  }

  /* --------------- *** Restore Arrow Visibility *** --------------- */

  const swiperButtonsContainer = parentSection?.querySelector(".swiper-buttons");

  if (swiperButtonsContainer) {
    swiperButtonsContainer.style.display = "";
  }

  /* --------------- *** Recalculate Slider State *** --------------- */

  const swiperHost = targetTab.querySelector("swiper-component");
  const swiperInstance =
    swiperHost?.swiper ||
    swiperHost?.swiperInstance ||
    swiperHost?.querySelector(".swiper")?.swiper;

  if (swiperInstance) {
    if (typeof swiperInstance.update === "function") {
      swiperInstance.update();
    }

    if (typeof swiperInstance.slideTo === "function") {
      swiperInstance.slideTo(0, 0, false);
    }

    if (swiperInstance.navigation && typeof swiperInstance.navigation.update === "function") {
      swiperInstance.navigation.update();
    }
  }

  /* --------------- *** Update View All Link *** --------------- */

  const viewAllHref = triggerButton?.dataset?.viewAllHref;
  const viewAllButton = parentSection?.querySelector("[data-view-all-button]");

  if (viewAllHref && viewAllButton) {
    viewAllButton.dataset.viewAllHref = viewAllHref;
    viewAllButton.href = viewAllHref;
  } else if (!viewAllHref && viewAllButton) {
    if (viewAllButton.dataset.viewAllHref) {
      viewAllButton.href = viewAllButton.dataset.viewAllHref;
    }
  }

  window.themeSwiper?.notifyLayoutChange?.();
}

function clickDefaultTabs(root = document) {
  root.querySelectorAll("[data-default-open]").forEach((el) => {
    try {
      el.click();
    } catch (error) {
      // Keep initializing other sections even if one tab mapping is invalid.
    }
  });
}

// show the first tabs by default on load - data-default-open
clickDefaultTabs();

window.addEventListener("shopify:section:load", () => {
  clickDefaultTabs();
});
